// The five bottom-tab destinations. Each tab remembers the last page you were on in it.
export const TABS = [
	{ key: 'home', label: 'Home', icon: 'home', root: '/' },
	{ key: 'shop', label: 'Shop', icon: 'shop', root: '/shop' },
	{ key: 'kits', label: 'Birth Kits', icon: 'kits', root: '/kits' },
	{ key: 'bag', label: 'Bag', icon: 'bag', root: '/cart' },
	{ key: 'more', label: 'More', icon: 'menu', root: '/more' },
]

const lastPaths = {}

export function rememberTabPath(route, router) {
	if (!route.meta?.tab || route.meta.tabBar === false) return
	const { sheet, ...query } = route.query
	lastPaths[route.meta.tab] = router.resolve({ path: route.path, query, hash: route.hash }).fullPath
}

export function lastPathForTab(key) {
	return lastPaths[key]
}

// Scroll position per page, so tapping back to a tab lands where you left it.
const scrollByPath = {}
let tabNavigationPending = false

export function rememberScroll(route) {
	if (route?.path) scrollByPath[route.path] = window.scrollY
}

export function markTabNavigation() {
	tabNavigationPending = true
}

export function takeTabNavigation(to) {
	if (!tabNavigationPending) return null
	tabNavigationPending = false
	return to.meta?.keepAlive ? (scrollByPath[to.path] ?? 0) : 0
}
